/* =====================================================================
   Pen Tech – compare devices
   Works on top of Minimog's compare (assets/compare-product.js): the same
   localStorage list ("m-compare-products") and the same .m-compare-button
   buttons. This file adds:
   - a 4-device limit,
   - the bottom tray with the picked devices and "Compare now",
   - the compare page (sections/page-product-compare.liquid): a spec table
     fed by /products/<handle>?view=pt-compare.
   Strings come from snippets/pt-compare-i18n.liquid (#pt-cmp-i18n).
   ===================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('pt-cmp-i18n');
  if (!cfgEl) return;
  var T;
  try { T = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY = 'm-compare-products';
  var MAX = 4;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var page = document.querySelector('[data-pt-cmp-page]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(s, vars) {
    return String(s).replace(/%(\w+)%|\{\{\s*(\w+)\s*\}\}/g, function (m, a, b) { var k = a || b; return vars[k] != null ? vars[k] : m; });
  }

  /* ---------- the list (Minimog keeps a copy in memory, so change it through Minimog when it is there) ---------- */
  function cp() { return window.MinimogTheme && window.MinimogTheme.CompareProduct; }
  function read() {
    try { return Array.from(new Set(JSON.parse(localStorage.getItem(KEY)) || [])); } catch (e) { return []; }
  }
  function list() { var c = cp(); return c ? c.products.slice() : read(); }
  function write(arr) { try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) { /* private mode */ } }
  function add(h) {
    var c = cp();
    if (c) c.addToCompare(h); else if (read().indexOf(h) < 0) write(read().concat(h));
  }
  function remove(h) {
    var c = cp();
    if (c) { c.removeFromCompare(h); c.updateCompareCount(); } else write(read().filter(function (x) { return x !== h; }));
    syncButtons();
    renderTray();
  }

  /* buttons on cards / product page follow the list (class + Minimog's text swap) */
  function syncButtons(scope) {
    var items = list();
    (scope || document).querySelectorAll('.m-compare-button[data-product-handle]').forEach(function (b) {
      var on = items.indexOf(b.dataset.productHandle) > -1;
      if (b.classList.contains('added-to-compare') !== on) {
        b.classList.toggle('added-to-compare', on);
        var t = b.querySelector('.m-compare-button-text');
        if (t && t.dataset.revertText != null) {
          var x = t.dataset.revertText;
          t.dataset.revertText = t.textContent;
          t.textContent = x;
        }
      }
      if (b.classList.contains('pt-cmp-toggle')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* Runs before Minimog's own click handler (capture): enforce the limit, then refresh the tray. */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.m-compare-button[data-product-handle]');
    if (!b) return;
    var h = b.dataset.productHandle;
    var adding = !b.classList.contains('added-to-compare');
    if (adding && list().indexOf(h) < 0 && list().length >= MAX) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (minimized) setMin(false);
      toast(fmt(T.max, { max: MAX }));
      return;
    }
    if (!cp()) {               // Minimog's script missing – do the toggle here
      e.preventDefault();
      if (adding) add(h); else remove(h);
    }
    setTimeout(function () {
      syncButtons();
      if (adding && minimized) setMin(false);
      renderTray(adding ? h : null);
      if (page) renderPage();
    }, 0);
  }, true);

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    var c = cp();
    if (c) c.products = read();
    syncButtons();
    renderTray();
    if (page) renderPage();
  });

  /* ---------- product data ---------- */
  var cache = {};
  function getProduct(h) {
    if (!cache[h]) {
      cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '?view=pt-compare', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- tray ---------- */
  var tray, trayItems, trayCount, trayGo, trayHint, trayToast, trayPill, minimized = false, toastTimer;
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4 3 8l4 4M3 8h13M17 12l4 4-4 4M21 16H8"/></svg>';
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  try { minimized = sessionStorage.getItem('pt-cmp-min') === '1'; } catch (e) { minimized = false; }

  function buildTray() {
    tray = document.createElement('div');
    tray.className = 'pt-cmp-tray';
    tray.setAttribute('role', 'region');
    tray.setAttribute('aria-label', T.tray_label);
    tray.hidden = true;
    tray.innerHTML =
      '<button type="button" class="pt-cmp-tray__pill" data-pt-cmp-expand>' + ICON +
        '<span>' + esc(T.title) + '</span><b data-pt-cmp-pillcount></b></button>' +
      '<div class="pt-cmp-tray__main">' +
        '<div class="pt-cmp-tray__head"><strong>' + esc(T.title) + '</strong><span class="pt-cmp-tray__count" data-pt-cmp-count></span></div>' +
        '<ul class="pt-cmp-tray__items" data-pt-cmp-items></ul>' +
        '<div class="pt-cmp-tray__actions">' +
          '<p class="pt-cmp-tray__hint" data-pt-cmp-hint></p>' +
          '<button type="button" class="pt-cmp-tray__clear" data-pt-cmp-clear>' + esc(T.clear) + '</button>' +
          '<a class="pt-cmp-tray__go" data-pt-cmp-go href="' + esc(T.url) + '">' + esc(T.compare_now) + '</a>' +
        '</div>' +
        '<button type="button" class="pt-cmp-tray__min" data-pt-cmp-min aria-label="' + esc(T.hide) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>' +
      '</div>' +
      '<p class="pt-cmp-tray__toast" role="status" aria-live="polite" data-pt-cmp-toast></p>';
    document.body.appendChild(tray);
    trayItems = tray.querySelector('[data-pt-cmp-items]');
    trayCount = tray.querySelector('[data-pt-cmp-count]');
    trayGo = tray.querySelector('[data-pt-cmp-go]');
    trayHint = tray.querySelector('[data-pt-cmp-hint]');
    trayToast = tray.querySelector('[data-pt-cmp-toast]');
    trayPill = tray.querySelector('[data-pt-cmp-pillcount]');

    tray.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pt-cmp-remove]');
      if (rm) { e.preventDefault(); remove(rm.getAttribute('data-pt-cmp-remove')); return; }
      if (e.target.closest('[data-pt-cmp-clear]')) { list().forEach(remove); return; }
      if (e.target.closest('[data-pt-cmp-min]')) { setMin(true); return; }
      if (e.target.closest('[data-pt-cmp-expand]')) { setMin(false); return; }
      if (e.target.closest('[data-pt-cmp-go]') && list().length < 2) { e.preventDefault(); toast(T.need_more); }
    });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(tray);
  }

  function measure() {
    if (!tray) return;
    var h = tray.hidden ? 0 : tray.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--pt-cmp-h', Math.round(h) + 'px');
  }

  function setMin(on) {
    minimized = on;
    try { sessionStorage.setItem('pt-cmp-min', on ? '1' : '0'); } catch (e) { /* ignore */ }
    renderTray();
    if (!on) { var go = tray && tray.querySelector('[data-pt-cmp-go]'); if (go) go.focus({ preventScroll: true }); }
  }

  function toast(msg) {
    if (!tray) return;
    trayToast.textContent = msg;
    tray.classList.add('has-toast');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { tray.classList.remove('has-toast'); }, 3200);
  }

  function renderTray(justAdded) {
    if (page) return;                       // the compare page has its own controls
    var items = list();
    if (!tray) { if (!items.length) return; buildTray(); }
    var n = items.length;
    var html = '';
    for (var i = 0; i < MAX; i++) {
      var h = items[i];
      if (h) {
        html += '<li class="pt-cmp-slot is-filled' + (h === justAdded ? ' is-new' : '') + '" data-h="' + esc(h) + '">' +
          '<span class="pt-cmp-slot__img"></span>' +
          '<button type="button" class="pt-cmp-slot__x" data-pt-cmp-remove="' + esc(h) + '" aria-label="' + esc(T.remove) + '">' + X + '</button></li>';
      } else {
        html += '<li class="pt-cmp-slot" aria-hidden="true"><span>+</span></li>';
      }
    }
    trayItems.innerHTML = html;
    items.forEach(function (h) {
      getProduct(h).then(function (p) {
        var li = trayItems.querySelector('[data-h="' + CSS.escape(h) + '"]');
        if (!li) return;
        if (!p) { remove(h); return; }
        li.title = p.title;
        li.querySelector('.pt-cmp-slot__x').setAttribute('aria-label', T.remove + ' – ' + p.title);
        li.querySelector('.pt-cmp-slot__img').innerHTML = p.image
          ? '<img src="' + esc(sized(p.image, 160)) + '" alt="' + esc(p.title) + '" width="80" height="80">'
          : '<span>' + esc(p.title.slice(0, 2)) + '</span>';
      });
    });
    trayCount.textContent = fmt(T.count, { count: n, max: MAX });
    trayPill.textContent = n;
    trayGo.textContent = n > 1 ? fmt(T.compare_n, { count: n }) : T.compare_now;
    trayGo.classList.toggle('is-disabled', n < 2);
    trayGo.setAttribute('aria-disabled', n < 2 ? 'true' : 'false');
    trayHint.textContent = n < 2 ? T.need_more : '';
    var show = n > 0;
    if (show && tray.hidden) {
      tray.hidden = false;
      if (!reduce) { tray.classList.add('is-entering'); requestAnimationFrame(function () { requestAnimationFrame(function () { tray.classList.remove('is-entering'); }); }); }
    } else if (!show) {
      tray.hidden = true;
    }
    tray.classList.toggle('is-min', minimized);
    document.documentElement.classList.toggle('pt-cmp-on', show && !minimized);
    document.documentElement.classList.toggle('pt-cmp-min', show && minimized);
    measure();
  }

  /* ---------- compare page ---------- */
  var pageItems = null;

  function conditionClass(v) {
    var k = String(v || '').toLowerCase();
    var like = ['زي الجديد', 'ممتاز', '(a)', 'refurb', 'renew', 'like new', 'open box', 'grade a', 'excellent'];
    for (var i = 0; i < like.length; i++) if (k.indexOf(like[i]) > -1) return 'like-new';
    if (k.indexOf('new') > -1 || k.indexOf('جديد') > -1) return 'new';
    return 'used';
  }

  function cellValue(key, it) {
    if (key === 'availability') return it.available ? T.in_stock : T.sold_out;
    if (key === 'warranty') return T.warranty_value;
    return (it.specs && it.specs[key]) || '';
  }

  function cellHtml(key, it) {
    var v = cellValue(key, it);
    if (!v) return '<span class="pt-cmp-none" aria-label="' + esc(T.none) + '">—</span>';
    if (key === 'condition') return '<span class="pt-condition pt-condition--' + conditionClass(v) + '" dir="auto">' + esc(v) + '</span>';
    if (key === 'availability') {
      return '<span class="pt-cmp-stock ' + (it.available ? 'is-in' : 'is-out') + '">' + esc(v) + '</span>';
    }
    return '<span class="pt-cmp-val" dir="auto">' + esc(v) + '</span>';
  }

  function moreLink(items) {
    var pref = ['laptop', 'all-in-one', 'desktop', 'monitors', 'projector', 'accessories'];
    var cols = (items[0] && items[0].collections) || [];
    for (var i = 0; i < pref.length; i++) if (cols.indexOf(pref[i]) > -1) return root + 'collections/' + pref[i];
    return root + 'collections/all';
  }

  function waLink(items) {
    if (!T.wa_number) return '';
    var msg = T.wa_intro + '\n' + items.map(function (it, i) { return (i + 1) + ') ' + it.title + ' – ' + it.price; }).join('\n') + '\n' + T.wa_outro;
    return 'https://wa.me/' + T.wa_number + '?text=' + encodeURIComponent(msg);
  }

  function buildTable(items) {
    var n = items.length;
    var slot = n < MAX ? 1 : 0;
    var more = moreLink(items);
    var rows = T.rows.filter(function (r) {
      return items.some(function (it) { return !!cellValue(r[0], it); });
    });

    var head = '<div class="pt-cmp-row pt-cmp-row--head" role="row">' +
      '<div class="pt-cmp-label" role="columnheader"><span class="pt-cmp-label__count">' + esc(fmt(T.count, { count: n, max: MAX })) + '</span></div>';
    items.forEach(function (it) {
      var price = '<span class="pt-cmp-prod__now">' + esc(it.price) + '</span>' + (it.compareAt ? ' <s>' + esc(it.compareAt) + '</s>' : '');
      head += '<div class="pt-cmp-cell pt-cmp-prod" role="columnheader">' +
        '<button type="button" class="pt-cmp-prod__x" data-pt-cmp-remove="' + esc(it.handle) + '" aria-label="' + esc(T.remove + ' – ' + it.title) + '">' + X + '</button>' +
        '<a class="pt-cmp-prod__media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
          (it.image ? '<img src="' + esc(it.image) + '" alt="" width="480" height="480" loading="lazy">' : '') + '</a>' +
        '<a class="pt-cmp-prod__title" dir="auto" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        '<p class="pt-cmp-prod__price">' + price + '</p>' +
        '<form class="pt-cmp-prod__form" action="' + esc(root) + 'cart/add" method="post">' +
          '<input type="hidden" name="id" value="' + esc(it.variant) + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="m-button m-button--primary pt-cmp-prod__atc"' + (it.available ? '' : ' disabled') + '>' +
            esc(it.available ? T.add_to_cart : T.sold_out) + '</button>' +
        '</form>' +
      '</div>';
    });
    if (slot) {
      head += '<div class="pt-cmp-cell pt-cmp-slotcell" role="columnheader">' +
        '<a class="pt-cmp-add" href="' + esc(more) + '"><span class="pt-cmp-add__plus" aria-hidden="true">+</span>' +
        '<strong>' + esc(T.add_device) + '</strong><span>' + esc(T.add_device_text) + '</span></a></div>';
    }
    head += '</div>';

    var body = rows.map(function (r) {
      var key = r[0];
      var vals = items.map(function (it) { return String(cellValue(key, it)).toLowerCase().replace(/\s+/g, ' ').trim(); });
      var differs = vals.some(function (v) { return v !== vals[0]; });
      var html = '<div class="pt-cmp-row' + (differs ? ' is-diff' : '') + '" role="row">' +
        '<div class="pt-cmp-label" role="rowheader"><span>' + esc(r[1]) + '</span></div>';
      items.forEach(function (it) { html += '<div class="pt-cmp-cell" role="cell">' + cellHtml(key, it) + '</div>'; });
      if (slot) html += '<div class="pt-cmp-cell pt-cmp-slotcell" role="cell"></div>';
      return html + '</div>';
    }).join('');

    var cols = n + slot;
    var vars = '--pt-cmp-cd:repeat(' + cols + ',minmax(170px,1fr));--pt-cmp-min-d:' + (190 + cols * 170) + 'px;' +
      '--pt-cmp-cm:repeat(' + n + ',minmax(150px,1fr));--pt-cmp-min-m:' + (n * 150) + 'px';
    return '<div class="pt-cmp-scroll"><div class="pt-cmp-table" role="table" aria-label="' + esc(T.title) + '" style="' + vars + '">' +
      head + body + '</div></div>' +
      (slot ? '<a class="pt-cmp-add-m" href="' + esc(more) + '"><span aria-hidden="true">+</span> ' + esc(T.add_device) + '</a>' : '');
  }

  function showPage(items) {
    var body = page.querySelector('[data-pt-cmp-body]');
    var empty = page.querySelector('[data-pt-cmp-empty]');
    var tools = page.querySelector('[data-pt-cmp-tools]');
    var help = page.querySelector('[data-pt-cmp-help]');
    var none = !items.length;
    empty.hidden = !none;
    tools.hidden = none;
    body.hidden = none;
    if (help) {
      var wa = none ? '' : waLink(items);
      help.hidden = !wa;
      var a = help.querySelector('a');
      if (a && wa) a.href = wa;
    }
    if (none) { body.innerHTML = ''; return; }
    body.innerHTML = buildTable(items);
    if (items.length === 1) {
      var hint = document.createElement('p');
      hint.className = 'pt-cmp-page__one';
      hint.textContent = T.need_more;
      body.insertBefore(hint, body.firstChild);
    }
  }

  function renderPage() {
    var hs = list();
    if (pageItems && pageItems.length === hs.length && pageItems.every(function (it, i) { return it.handle === hs[i]; })) return;
    if (!hs.length) { pageItems = []; showPage([]); return; }
    Promise.all(hs.map(getProduct)).then(function (res) {
      res.forEach(function (p, i) { if (!p) remove(hs[i]); });
      var items = res.filter(Boolean);
      var now = list();
      pageItems = items.filter(function (it) { return now.indexOf(it.handle) > -1; });
      showPage(pageItems);
    });
  }

  if (page) {
    page.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pt-cmp-remove]');
      if (rm) {
        var h = rm.getAttribute('data-pt-cmp-remove');
        remove(h);
        pageItems = (pageItems || []).filter(function (it) { return it.handle !== h; });
        showPage(pageItems);
        return;
      }
      if (e.target.closest('[data-pt-cmp-clear]')) {
        list().forEach(remove);
        pageItems = [];
        showPage([]);
      }
    });
    var diff = page.querySelector('[data-pt-cmp-diff]');
    if (diff) {
      var setDiff = function () { page.classList.toggle('is-diff-on', diff.checked); };
      diff.addEventListener('change', setDiff);
      setDiff();
    }
  }

  /* ---------- start ---------- */
  function start() {
    syncButtons();
    if (page) renderPage(); else renderTray();
  }
  // Minimog's compare-product.js is deferred too and loads first; wait a tick so its list is ready.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  else setTimeout(start, 0);

  // cards that arrive later (filters, finder results) call this
  window.PTCompare = { sync: syncButtons, refresh: function () { syncButtons(); renderTray(); } };
})();
